import { render, staticRenderFns } from "./ExpenseStatusChip.vue?vue&type=template&id=caed8546"
import script from "./ExpenseStatusChip.vue?vue&type=script&lang=js"
export * from "./ExpenseStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports